import React from 'react';
import { SectionHeading } from './SectionHeading';
import { SOLUTION_PILLARS } from '../data/content';
export function SolutionSection() {
  return <section className="radial-green-soft py-10 sm:py-12" style={{
    paddingTop: "1px",
    paddingBottom: "8px"
  }} data-id="element-168" data-mp="3abc9ogzhdxpg">
      <div className="mx-auto max-w-content px-5" data-id="element-169" data-mp="3o6xsu7j19n9y">
        <SectionHeading eyebrow="THE SOLUTION" title="Knowing where —" highlight="and why" data-id="element-170" data-mp="3j9605bakdx4p" />

        <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-171" data-mp="13j97yrtuckz">
          {SOLUTION_PILLARS.map(pillar => <li key={pillar.title} className="flex h-full items-start gap-3 rounded-2xl border border-lime-700/40 bg-ink-850 p-5" data-id="element-172" data-mp="3t96ojbnaj3fr">
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-lime-600/15 text-lg" aria-hidden="true" data-id="element-173" data-mp="atw3wjtcvm4u">
                {pillar.emoji}
              </span>
              <div data-id="element-174" data-mp="ktmx8i66jv3c">
                <h3 className="text-sm font-bold leading-snug text-white sm:text-base" data-id="element-175" data-mp="kt3dcvwyywmo">
                  {pillar.title}
                </h3>
                <p className="mt-1.5 text-sm leading-snug text-white/60" data-id="element-176" data-mp="36avrr3dxat6h">{pillar.body}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}